// extracted by mini-css-extract-plugin
export default {"container":"WhatWeLearn_container__Ve42K","about":"WhatWeLearn_about__Il-tE","li":"WhatWeLearn_li__o18aA","joinNow":"WhatWeLearn_joinNow__2HIbd"};